import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { th } from 'date-fns/locale';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/services/auth.service';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { VG_DATE_PROVIDERS } from '../../vg-datepicker/vg-datepicker';

@Component({
    selector: 'app-medication',
    templateUrl: './medication.component.html',
    styleUrls: ['./medication.component.css'],
    standalone: false
})
export class MedicationComponent {

    medications: any[] = [
    {
      id: 1,
      name: 'Paracetamol XY12',
      dosage: '250 mg',
      timing: 'Before Breakfast',
      dueTime: '08:00 AM',
      icon: '💊'
    },
    {
      id: 2,
      name: 'Cipla citrin Y67',
      dosage: '250 mg',
      timing: 'After Breakfast',
      dueTime: '10:00 AM',
      icon: '💊'
    },
    {
      id: 3,
      name: 'Azithromycin',
      dosage: '250 mg',
      timing: 'After Lunch',
      dueTime: '02:30 PM',
      icon: '💊'
    },
    {
      id: 4,
      name: 'Azithromycin',
      dosage: '250 mg',
      timing: 'After Lunch',
      dueTime: '02:30 PM',
      icon: '💊'
    },
    {
      id: 5,
      name: 'Azithromycin',
      dosage: '250 mg',
      timing: 'After Lunch',
      dueTime: '02:30 PM',
      icon: '💊'
    }
  ];
    @Input() medicationData: any[] =[];
    medlist: any[] = [];
    searchText: string = '';

  constructor(
    private router: Router,
    private auth:AuthService , 
    private toastr: ToastrService,
    private dialog: MatDialog,

  ) {}
    
  
    ngOnInit() {
      this.getMedication();

    }

    get filteredMedication(): any[] {
      if (!this.searchText?.trim()) {
        return [...this.medicationData].reverse(); // copy & reverse
      }

      const lower = this.searchText.toLowerCase();
      return this.medicationData
        .filter(item =>
          item.medicationName?.toLowerCase().includes(lower)
        )
        .reverse();
    }


    getMedication(){
    this.auth.profile_details_cat('medication').subscribe((res:any) =>{
      this.medicationData = res?.data?.medication || [];
      console.log('Medication List:', this.medicationData);
    }, error => {
      console.error('Error fetching medication list:', error);
      this.toastr.error('Failed to fetch medication list');
    });
  }

   openDialog(){
    const dialogRef = this.dialog.open(MedicationDialogComponent, {
    width: '600px',
    maxWidth: '95vw',
      data: { 
        mode: 'add'
      },
      disableClose: true,
      autoFocus: false,
    
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getMedication();
        // this.toastr.success('Medication added successfully!');
      }
    });
   }

   /** Opens the read-only details dialog for the selected medication. Its Edit button hands over to the existing edit dialog. */
   onView(med: any) {
    this.dialog.open(MedicationDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      autoFocus: 'dialog',
      data: {
        mode: 'view',
        details: med
      }
    }).afterClosed().subscribe(result => {
      if (result === 'edit') {
        this.onEdit(med);   // same record, existing edit dialog, existing reload-on-save
      }
    });
   }

   onEdit(med:any){
    this.dialog.open(MedicationDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      autoFocus: false,
      data: {
        mode: 'edit',
        details:med
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.getMedication()
      }
    });

   }
  getNextDoseTime(med: any): string {
  const times = Array.isArray(med?.timeFrequency)
    ? med.timeFrequency.map((t: { time: string }) => t?.time).filter(Boolean)
    : [];

  return times.length
    ? `Due - ${times.join(', ')}`
    : 'All doses done';
}


  onDelete(med: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete Medication',
        message: 'Are you sure want to delete this medication?',
        sub: 'You will not be able to recover it once it is deleted.'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && med) {
        this.auth.del_profile_details_cat('medication', med.id).subscribe(
          (res: any) => {
            console.log('Medication deleted:', res);
            // Remove from local list
            this.medicationData = this.medicationData.filter(m => m.id !== med.id);
            this.toastr.success('Medication deleted successfully');
          },
          error => {
            console.error('Error deleting medication:', error);
            this.toastr.error('Failed to delete medication');
          }
        );
      }
    });
  }

  goBack(): void {
    this.router.navigate(["/health/dashbord"])
  }
}


/** One read-only row in the View Details dialog. */
export interface MedicationViewField {
  label: string;
  value: string;      // already formatted; '—' when empty
  empty: boolean;
  full: boolean;      // spans both columns
  chips?: string[];   // dosage times, shown as chips instead of text
}

@Component({
    templateUrl: './add-medication.html',
    styleUrls: ['./medication.component.css'],
    providers: VG_DATE_PROVIDERS,   // dates display as "Oct 13, 2026"
    standalone: false
})
export class MedicationDialogComponent {
  medForm: FormGroup;
  medlist: any[] = [];
  bloodGroups: any[] = [];
  ethnicities: any[]=[];
  time:any[]=[];
  medUnits = ["g", "IU", "mcg", "mcg/hr" , "mcg/ml" , "mEq", "mg", "mg/cm2", "mg/g" , "mg/ml", "mL", "%"]
  dialogMode = 'add';
  time_freq:any[]=[{
    "time":"08:00 AM",
    "dosage": 1

   }];
   no_of_times=1;
  formBuilder: any;
   formattime: any;
  maxDate = new Date()
  tomorrow =  new Date(this.maxDate.setDate(this.maxDate.getDate()+1));
  today = new Date();
  /** Date limits for the pickers. A date that is already saved on the record is never rejected, so editing an old medication can still be saved. */
  endMin: Date = this.tomorrow;
  startMax: Date = this.today;
  edit_time_status = false;
  filteredConditions:any[]=[];
  submitted = false;
  sameValue = (a: unknown, b: unknown): boolean => (a ?? '') === (b ?? '');

  

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<MedicationDialogComponent>,
    public auth: AuthService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data:{mode: 'add' | 'edit' | 'view',details?: any}
  ) 
 
  {   console.log(data)
     this.dialogMode = data.mode;
     this.viewFields = data.mode === 'view' ? this.buildViewFields(data.details || {}) : [];
      this.medForm = this.fb.group({
      medCondition: [data.details?.medCondition || '', Validators.required],
      medicationName: [data.details?.medicationName || '', Validators.required],
      numberOfTimes: [data.details?.numberOfTimes||1 , [Validators.required, Validators.min(0), Validators.max(24)]],
      strength: [data.details?.strength || '', [Validators.min(0), Validators.max(10000000000)]],
      unit: [data.details?.unit || '', Validators.required],
      startDate: [data.details?.startDate? new Date(data.details.startDate) : '', Validators.required],
      endDate: [data.details?.endDate ? new Date(data.details?.endDate): ''],
      frequency: [data.details?.frequency||'' , Validators.required],
      qty: [1],
      timeFrequency: this.fb.array([]),
      comment: [data.details?.comment || '']

    });
     console.log(this.medForm)

    const savedEnd = data.details?.endDate ? new Date(data.details.endDate) : null;
    if (savedEnd && !isNaN(savedEnd.getTime()) && savedEnd < this.tomorrow) { this.endMin = savedEnd; }
    const savedStart = data.details?.startDate ? new Date(data.details.startDate) : null;
    if (savedStart && !isNaN(savedStart.getTime()) && savedStart > this.today) { this.startMax = savedStart; }
  }
   
  ngOnInit() {
    if (this.dialogMode === 'view') { return; }   // read-only: no lookup call, no form subscriptions
    this.getEthnicity();
    this.medForm.get('medCondition')?.valueChanges.subscribe(value => {
    const filterValue = value?.toLowerCase() || '';
    this.filteredConditions = this.medlist?.filter((condition:any) =>
      condition.title.toLowerCase().includes(filterValue)
    );
  });

     
        if (this.dialogMode === 'edit' && this.data.details?.timeFrequency?.length >0) {
      this.time_freq = this.data.details.timeFrequency;
    }

     this.medForm.get('numberOfTimes')?.valueChanges.subscribe(value => {
    const frequency = this.medForm.get('frequency')?.value;
    this.calculateFrequency(value, frequency);
  });

    console.log('Form Values:', this.medForm.value);
    
  }

  openPicker(event: Event): void {
    try { (event.target as HTMLInputElement).showPicker?.(); } catch { }
  }

  changeDosage(delta: number): void {
    const ctrl = this.medForm.get('numberOfTimes');
    const next = Math.min(24, Math.max(1, (Number(ctrl?.value) || 1) + delta));
    ctrl?.setValue(next);
    ctrl?.markAsDirty();
  }

  getError(controlName: string): string | null {
      const control = this.medForm.get(controlName);

      if (!control || !control.errors || !control.touched) {
        return null; // only show errors when touched
      }

      if (control.errors['required']) {
        return 'This field is required';
      }

      if (control.errors['minlength']) {
        const requiredLength = control.errors['minlength'].requiredLength;
        return `Minimum length is ${requiredLength}`;
      }

      if (control.errors['maxlength']) {
        const requiredLength = control.errors['maxlength'].requiredLength;
        return `Maximum length is ${requiredLength}`;
      }

      if (control.errors['min']) {
        return `Minimum value is ${control.errors['min'].min}`;
      }

      if (control.errors['max']) {
        return `Maximum value is ${control.errors['max'].max}`;
      }

      if (control.errors['pattern']) {
        return 'Invalid format';
      }

      if (control.errors['matDatepickerMin']) {
        return 'Choose a later date';
      }

      if (control.errors['matDatepickerMax']) {
        return 'Choose today or an earlier date';
      }

      if (control.errors['matDatepickerParse']) {
        return 'Enter a valid date';
      }

      return null;
    }

 time_edit(time: string, index: number, total: number) {
  this.edit_time_status = true;
  console.log(time)
  // Convert "HH:mm" string to Date
  const [hours, minutes] = time.split(':').map(Number);
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);

  // Format to "hh:mm AM/PM"
  const timef = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });

  this.time_freq[index].time = timef;
  console.log(this.time_freq)
}

 get timeFrequency(): FormArray {
    return this.medForm.get('timeFrequency') as FormArray;
  }

 setTimeFrequency(times: any[]) {
    const timeArray = this.medForm.get('timeFrequency') as FormArray;
    timeArray.clear();
    times.forEach(t => {
      timeArray.push(this.fb.group({
        time: [t.time],
        dosage: [t.dosage]
      }));
    });
  }

   calculateFrequency(freq: number, sel: string): any[] {
  if (this.dialogMode === "edit" && !this.medForm.get('numberOfTimes')?.dirty) {
    return this.time_freq;
  }

  this.time = [];
  this.time_freq = [];

  // Special case: once a day
  if (sel === "everyDay" && freq === 1) {
    const singleTime = "08:00 AM";
    this.time_freq = [{ time: singleTime, dosage: 1 }];
    this.setTimeFrequency(this.time_freq);
    return this.time_freq;
  }

  if (freq > 24 || freq < 1) return [];

  const freqMaxMap: { [key: number]: number } = {
    1: 24, 2: 24, 3: 12, 4: 12, 5: 16, 6: 14,
    7: 16, 8: 18, 9: 20, 10: 22, 11: 23, 12: 24
  };
  const maxTime = freqMaxMap[freq] || 24;

  const step = Math.ceil(maxTime / freq);
  let startTime = 8;

  for (let i = 0; i < freq; i++) {
    const formatted = this.formatTime(startTime);
    this.time.push(formatted);
    startTime += step;
  }

  this.time_freq = this.time.map(t => ({ time: t, dosage: 1 }));
  this.setTimeFrequency(this.time_freq);
  return this.time_freq;
}
get_time(time: string): string {
  const [hourPart, minutePart] = time.split(/[: ]/); // Split by : and space
  const hour = parseInt(hourPart, 10);
  const minute = parseInt(minutePart, 10);
  const isPM = time.toUpperCase().includes('PM');

  let hours24 = isPM ? (hour % 12) + 12 : hour % 12; // handle 12 PM and 12 AM correctly

  return `${hours24.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
}


// Helper function
private formatTime(hour: number): string {
  const mod = hour % 24;
  const h = mod % 12 || 12;
  const suffix = mod < 12 ? "AM" : "PM";
  return `${h.toString().padStart(2, '0')}:00 ${suffix}`;
}

 

  onCancel(): void {
    this.dialogRef.close();
  }

  // ---------- View Details (read-only) ----------
  viewFields: MedicationViewField[] = [];

  /** View Details -> Edit: closes this dialog; the list opens the existing edit dialog for the same record. */
  onEditFromView(): void {
    this.dialogRef.close('edit');
  }

  private viewText(v: unknown): string {
    if (v === null || v === undefined) { return ''; }
    const s = String(v).trim();
    return (s === 'null' || s === 'undefined' || s === 'NaN') ? '' : s;
  }

  /** 'MM-dd-yyyy' (API) or 'yyyy-MM-dd[...]' -> 'Oct 13, 2026'. Parsed by hand, so there is no timezone shift. */
  private viewDate(v: unknown): string {
    const s = this.viewText(v);
    if (!s) { return ''; }
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let y = 0, m = 0, d = 0;
    const us = s.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
    const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (us) { m = +us[1]; d = +us[2]; y = +us[3]; }
    else if (iso) { y = +iso[1]; m = +iso[2]; d = +iso[3]; }
    return (m >= 1 && m <= 12 && d >= 1 && d <= 31) ? `${months[m - 1]} ${d}, ${y}` : s;   // unrecognised: show as returned
  }

  /** Builds the read-only rows from the selected medication (same fields the edit form uses). */
  private buildViewFields(d: any): MedicationViewField[] {
    const f = (label: string, value: string, full = false): MedicationViewField =>
      ({ label, value: value || '—', empty: !value, full });
    const text = (v: unknown) => this.viewText(v);

    const freq = text(d.frequency);
    const isDaily = freq === 'everyDay';
    const freqLabel = isDaily ? 'Every Day' : (freq === 'asNeeded' ? 'As Needed' : freq);

    const rows: MedicationViewField[] = [
      f('Medical Condition', text(d.medCondition)),
      f('Medication Name', text(d.medicationName)),
      f('Strength', text(d.strength)),
      f('Unit', text(d.unit)),
      f('Start Date', this.viewDate(d.startDate)),
      f('End Date', this.viewDate(d.endDate)),
      f('Frequency', freqLabel)
    ];

    if (isDaily) {
      rows.push(f('Dosage (per day)', text(d.numberOfTimes)));
      const times: string[] = (Array.isArray(d.timeFrequency) ? d.timeFrequency : [])
        .map((x: any) => text(x?.time)).filter((x: string) => x.length > 0);   // every configured time, none dropped
      rows.push({ ...f('Dosage Times', times.join(', '), true), chips: times });
    }

    rows.push(f('Additional Notes', text(d.comment), true));
    return rows;
  }

  onSave(): void {
    if (this.medForm.invalid) {
      this.medForm.markAllAsTouched();
      return;
    }
    // if (this.medForm.invalid) {
    //   this.toastr.error('Please fill out required fields');
    //   this.medForm.markAsTouched();
    //   return;
    // }

    const freq = this.medForm.get('frequency')?.value?.toLowerCase();
    if (freq === 'asneeded') {
      this.medForm.patchValue({ numberOfTimes: 0 }, { emitEvent: false });
    }

    let startDate ='';
      let endDate ='';
    if (this.medForm.valid) {
     
        startDate = this.datePipe.transform(this.medForm.value.startDate, 'MM-dd-yyyy') || ''
    
      if(this.medForm.value.endDate) {
        
          endDate = this.datePipe.transform(this.medForm.value.endDate, 'MM-dd-yyyy') || ''
      
      }

      if(this.medForm.value.numberOfTimes === 0)
        this.time_freq = []
      
      console.log('Form Values:', this.medForm.value);
      console.log(this.time_freq)
      this.medForm.patchValue({timeFrequency: this.time_freq})
        let payload= {
         "medCondition": this.medForm.value.medCondition,
      "medicationName": this.medForm.value.medicationName,
      "numberOfTimes": Number(this.medForm.value.numberOfTimes),
      "strength": this.medForm.value.strength,
      "unit": this.medForm.value.unit,
      "startDate": startDate,
      "endDate": endDate,
      "frequency": this.medForm.value.frequency,
      "timeFrequency": this.time_freq,
      "qty": "1",
      "comment": this.medForm.value.comment
      }

     
      if(this.dialogMode === 'add'){
        this.auth.add_profile_details_cat('medication',payload).subscribe((res:any) => {
        if (res) {   
          this.toastr.success(res.msg);
          this.dialogRef.close(this.medForm.value);
        }
      });

      } else {
        console.log("edit:",this.medForm.value)
        this.auth.update_profile_details_cat('medication',this.data.details?.id,payload).subscribe((res:any) => {
        if (res) {   
          this.toastr.success(res.msg);
          this.dialogRef.close(this.medForm.value);
        }
      });
      }
      
      
    }
    else {
      this.dialogRef.close(this.medForm.value);
    }
  }

  
  getEthnicity(){
    this.auth.get_medical_condition().subscribe((res:any) =>{
      this.medlist = res.data.medicalcondition;
    
    });

  }


 
}